// export function formatNumberToKAndM(number: number): string {
//     if (number >= 1000000) {
//         return Math.round(number / 1000000) + "M";
//     } else if (number >= 1000) {
//         return Math.round(number / 1000) + "K";
//     } else {
//         return number.toString();
//     }
// }
export function formatNumberToKAndM(number: number): string {
    //-----------------------------------------old code-----------------------------
    // const absNumber = Math.abs(number);
    // let formattedNumber;
    
    // if (absNumber >= 1000000) {
    //     formattedNumber = Math.round(absNumber / 1000000) + "M";
    // } else if (absNumber >= 1000) {
    //     formattedNumber = Math.round(absNumber / 1000) + "K";
    // } else {
    //     formattedNumber = absNumber.toString();
    // }
    
    // return number < 0 ? "-" + formattedNumber : formattedNumber;
    //-------------------------------------------new code----------------------------

    const isNegative = number < 0;
    number = Math.abs(number);

    if (number >= 1000000) {
        return (isNegative ? "-" : "") + (Math.trunc((number / 1000000) * 10) / 10).toFixed(1).replace(/\.0$/, '') + "M";
    } else if (number >= 1000) {
        return (isNegative ? "-" : "") + (Math.trunc((number / 1000) * 10) / 10).toFixed(1).replace(/\.0$/, '') + "K";
    } else {
        return (isNegative ? "-" : "") + number.toString();
    }
}



export function formatNumberToKAndMwithoutsign(number: number): string {
    // const absNumber = Math.abs(number);
    // let formattedNumber;
    
    // if (absNumber >= 1000000) {
    //     formattedNumber = Math.round(absNumber / 1000000) + "M";
    // } else if (absNumber >= 1000) {
    //     formattedNumber = Math.round(absNumber / 1000) + "K";
    // } else {
    //     formattedNumber = absNumber.toString();
    // }
    
    // return number < 0 ? "" + formattedNumber : formattedNumber;

    const isNegative = number < 0;
    number = Math.abs(number);

    if (number >= 1000000) {
        return (isNegative ? "" : "") + (Math.trunc((number / 1000000) * 10) / 10).toFixed(1).replace(/\.0$/, '') + "M";
    } else if (number >= 1000) {
        return (isNegative ? "" : "") + (Math.trunc((number / 1000) * 10) / 10).toFixed(1).replace(/\.0$/, '') + "K";
    } else {
        return (isNegative ? "" : "") + number.toString();
    }
}
